export const NET_PARTNER = "10043";
export const NET_PARTNER_KEY = "##QDcafa*&^";



// WEBPACK FOOTER //
// ./src/assets/js/requestConfig.js